module.exports = __webpack_public_path__ + "media/calenderClock.0eee4ad7.svg";